// Module
var code = "<tr> <td style=max-width:150px;overflow-x:hidden;white-space:nowrap;text-overflow:ellipsis><%- rcid %></td> <td style=max-width:150px;overflow-x:hidden;white-space:nowrap;text-overflow:ellipsis><%- name %></td> <td> <button type=button class=\"btn btn-success unfilterLink\" title=Show>Show</button> </td> </tr> ";
// Exports
module.exports = code;